import React, { useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import Header from '../Header/Header';
import {
  HeroContainer,
  HeroWrapper,
  HeroLeft,
  HeroRight,
  Image,
  ScrollDown,
  ScrollLink,
} from './HeroElements';
import { TypeAnimation } from 'react-type-animation';
import ScrollAnimation from 'react-animate-on-scroll';

function Hero() {
  const [isOpen, setIsOpen] = useState(false);
  const [showSubtitle, setShowSubtitle] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true); 

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <main>
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Header toggle={toggle} />
      <HeroContainer>
        <HeroWrapper>
          <HeroLeft>
            <ScrollAnimation animateIn="fadeIn" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <TypeAnimation
                cursor={false}
                sequence={[
                  'Hi, I\'m Suraz Nepal.',
                  () => {
                    setShowSubtitle(true);
                    setShowScrollDown(true); 
                  }
                ]}
                speed={{ type: "keyStrokeDelayInMs", value: 250 }}
                wrapper="h1"
                repeat={0}
              />
              {showSubtitle &&
                <div style={{ color: '#181615ff' }}> {}
                  <TypeAnimation
                    cursor={true}
                    sequence={[
                      'A Full-Stack Developer.',
                      1000,
                      'A Centennial Graduate.',
                      'I design and code beautifully simple things, and I love what I do.',
                      500,
                      "You can scroll down to see my projects now...",
                      300,
                      "Seriously, my projects are really cool, go check them out!",
                      1000,
                      "You're uh...",
                      1000,
                      "You're uh... still here?",
                      1000,
                      "Ok, this has been fun, but I'm gonna restart the loop now...",
                      "See ya! :)",
                      500,
                    ]}
                    speed={200}
                    deletionSpeed={65}
                    wrapper="h5"
                    repeat={Infinity}
                  />
                </div>
              }
            </ScrollAnimation>
          </HeroLeft>
          <HeroRight>
              <Image src="/hero.png" alt="hero" />
          </HeroRight>
        </HeroWrapper>
        {showScrollDown && <ScrollAnimation animateIn="flipInX" offset={10}>
          <ScrollDown to="projects" id="scrollDown">
            <ScrollLink>
              Scroll down
              <img src="/scroll-down.svg" alt="scroll-down" />
            </ScrollLink>
          </ScrollDown>
        </ScrollAnimation>}
      </HeroContainer>
    </main>
  );
}

export default Hero;
